import VacancyList from './VacancyList';
export default VacancyList;